import React from 'react';
import { gameImageSrcSets } from '@/utils/images/attributes';

import './styles/@theme';

const EXPLORE_ROW_TILE_SIZE = { mobile: 55, tablet: 55 };

type GameTileImageMobileProps = {
    logoUrl: string;
    backgroundUrl?: string;
    customBackgroundColor?: string;
};

export const GameTileImageMobile = ({ logoUrl, backgroundUrl, customBackgroundColor }: GameTileImageMobileProps) => {
    return (
        <div className="image-container">
            <div className="game-tile__image--mobile" style={{ backgroundColor: customBackgroundColor }}>
                <img
                    className="tile-background"
                    src={backgroundUrl}
                    alt=""
                    loading="lazy"
                    {...gameImageSrcSets(backgroundUrl ?? '', EXPLORE_ROW_TILE_SIZE)}
                />
                <img
                    className="tile-logo"
                    src={logoUrl}
                    alt={logoUrl}
                    loading="lazy"
                    {...gameImageSrcSets(logoUrl, EXPLORE_ROW_TILE_SIZE)}
                />
            </div>
        </div>
    );
};
